import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Dropdown,
  Grid,
  Header,
  Label,
} from 'semantic-ui-react';
import clone from 'clone';
import _ from 'lodash';
import AppForm from '../../components/AppForm';
import CurrencySymbol from '../../components/CurrencySymbol';
import LoanAmount from '../../components/LoanAmount';
import { flashErrorMessage } from '../../actions/flash';

export default class UpdateLoanInfo extends Component {
  static propTypes = {
    bookingCustomerData: PropTypes.shape({
      spaValue: PropTypes.number,
    }),
    creditCheckReportData: PropTypes.shape({
      currentLoanAmount: PropTypes.number,
      monthlyCommitment: PropTypes.number,
    }),
    onChange: PropTypes.func,
    pathCheck: PropTypes.bool,
  }
  static defaultCustomerCreditReportsData = {
    currentLoanAmount: 0,
    monthlyCommitment: 0,
  }
  static contextType = {
    store: PropTypes.object,
  }
  static getPropsToState = (props) => {
    const creditCheckReportData = Object.assign({}, props.creditCheckReportData || {});
    return {
      creditCheckReportData,
      oriCreditCheckReportData: clone(creditCheckReportData),
    };
  }
  constructor(props) {
    super(props);
    const state = UpdateLoanInfo.getPropsToState(props);
    this.state = {
      ...state,
      displayedPercentage: '',
      errMessages: [],
      loanPercentage: 0,
    };
  }
  componentDidMount() {
    this.props.pathCheck ? this.getDefaultLoanAmount() : null;
  }
  componentWillReceiveProps(nextProps) {
    const state = UpdateLoanInfo.getPropsToState(nextProps);
    if (JSON.stringify(this.state.oriCreditCheckReportData) === JSON.stringify(state.oriCreditCheckReportData)) {
      state.creditCheckReportData = this.state.creditCheckReportData;
    }
    this.setState({ state });
  }
  getDefaultLoanAmount() {
    const { bookingCustomerData } = this.props;
    const { creditCheckReportData } = this.state;
    const newCreditCheckReportData = Object.assign({}, creditCheckReportData);
    newCreditCheckReportData.currentLoanAmount = _.toNumber((bookingCustomerData.spaValue * 0.9).toFixed(2));
    this.setState({ creditCheckReportData: newCreditCheckReportData, displayPercentage: '90%' });
  }
  percentageOptions = [
    {
      text: '95%',
      value: '0.95',
    },
    {
      text: '90%',
      value: '0.90',
    },
    {
      text: '85%',
      value: '0.85',
    },
    {
      text: '80%',
      value: '0.80',
    },
    {
      text: '75%',
      value: '0.75',
    },
    {
      text: '70%',
      value: '0.70',
    },
    {
      text: '65%',
      value: '0.65',
    },
    {
      text: '60%',
      value: '0.60',
    },
    {
      text: '55%',
      value: '0.55',
    },
    {
      text: '50%',
      value: '0.50',
    },
    {
      text: '45%',
      value: '0.45',
    },
    {
      text: '40%',
      value: '0.40',
    },
    {
      text: '35%',
      value: '0.35',
    },
    {
      text: '30%',
      value: '0.30',
    },
    {
      text: '25%',
      value: '0.25',
    },
    {
      text: '20%',
      value: '0.20',
    },
    {
      text: '15%',
      value: '0.15',
    },
    {
      text: '10%',
      value: '0.10',
    },
    {
      text: '5%',
      value: '0.5',
    },
  ];
  handleCheckChanges() {
    if (this.props.onChange) {
      const { creditCheckReportData } = this.state;
      this.props.onChange(creditCheckReportData);
    }
  }
  handleDropdownChange = (e, { value }) => {
    const { creditCheckReportData } = this.state;
    e.preventDefault();
    const newCreditCheckReportData = Object.assign({}, creditCheckReportData);
    newCreditCheckReportData.currentLoanAmount = _.toNumber((this.props.bookingCustomerData.spaValue * value).toFixed(2));
    this.setState({ loanPercentage: value, creditCheckReportData: newCreditCheckReportData }, () => {
      this.handleCheckChanges();
    });
  }
  handleFlashError = () => {
    const { store } = this.context;
    store.dispatch(flashErrorMessage('Please tick the checkbox to generate ctos report'));
  }
  handleInputChange = (e, data) => {
    e.preventDefault();
    const { creditCheckReportData } = this.state;
    creditCheckReportData[data.name] = _.toNumber(data.value);
    this.setState({ creditCheckReportData }, () => {
      this.handleCheckChanges();
    });
  }
  render() {
    const { bookingCustomerData } = this.props;
    const { displayPercentage, creditCheckReportData, loanPercentage } = this.state;
    return (
      <div>
        {
          this.props.pathCheck ? (
            <Container
              style={{
                border: '1px solid rgba(164, 179, 193, 1)',
                padding: '0.7rem 2rem',
                borderRadius: '0.25rem',
                background: 'rgba(231, 236, 241, 1)',
              }}
            >
              <Grid>
                <Grid.Row>
                  <Grid.Column>
                    <Label content="Loan Amount" style={{ background: 'transparent', color: 'black' }} />
                    <div style={{ fontSize: '1.7rem', fontWeight: 'bold', margin: '0.5rem' }}>
                      <LoanAmount
                        format="0,000,000.00"
                        amount={_.toNumber(creditCheckReportData.currentLoanAmount)}
                        prefix={<CurrencySymbol />}
                      />
                    </div>
                  </Grid.Column>
                </Grid.Row>
                <div className="loanInfoContainer">
                  <Grid.Row>
                    <Grid.Column>
                      <Header
                        as="h5"
                        style={{ marginBottom: '0.5em' }}
                        textAlign="left"
                        content="Selling Price"
                      />
                      <div className="spaValueContainer">
                        <LoanAmount
                          format="0,000,000.00"
                          amount={bookingCustomerData.spaValue}
                          prefix={<CurrencySymbol />}
                        />
                      </div>
                      <Header
                        as="h5"
                        style={{ marginBottom: '0.5em' }}
                        textAlign="left"
                        content="Loan Percentage"
                      />
                      <Dropdown
                        fluid
                        placeholder="Loan Percentage"
                        selection
                        options={this.percentageOptions}
                        onChange={this.handleDropdownChange}
                        trigger={loanPercentage === 0 && creditCheckReportData.currentLoanAmount !== 0 ? displayPercentage : null}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </div>
              </Grid>
            </Container>
          ) : (
            <Grid>
              <Grid.Row>
                <Grid.Column textAlign="right">
                  <Header
                    as="h5"
                    style={{ marginBottom: '0.5em' }}
                    textAlign="left"
                    content="Loan Amount"
                  />
                  <AppForm.Input
                    type="number"
                    step="0.01"
                    name="currentLoanAmount"
                    value={_.toNumber(creditCheckReportData.currentLoanAmount)}
                    onChange={this.handleInputChange}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          )
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/CreditCheck/UpdateLoanInfo.jsx